<template>
    <!-- v-if="Object.keys(nuveiData).length === 0" -->
    <div id="form">
        <div v-if="tradingAccountList.totalLiveAccounts > 0">
            <div class="mainTitle text-center mb-3">
                <h2 class="mb-3">{{ $t("dep_acc_fund_depFundAcc") }} <span v-if="account_id != ''">{{ account_id }}</span></h2>
                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != '' && trans_id == ''"></message-component>
            </div>
            <div class="fxdepositfund d-flex align-items-center justify-content-center accountList flex-wrap" v-if="shwStep == 1">
                <div
                    v-for="(list, key) in tradingAccountList.records"
                    :class="account_id == list.account_id ? 'accountBox selected' : 'accountBox'
                    "
                    v-if="parseInt(list.demo_live) == 1"
                    v-on:click.stop.prevent="
        act_account_id = list.act_account_id;
    account_id = list.account_id;
    currency_selected = list.currency;
    shwOption = false;
    "
                >
                    <div class="head d-flex align-items-center justify-content-between">
                        <div class="d-flex">
                            <div class="platformLogo pr-3">
                                <img
                                    :src="'../../../../static/fxView/images/' +
                                    $env_var.platformIcon[list.platform]
                                    "
                                    alt="mt4"
                                />
                            </div>
                            <div class="detail">
                                <div class="tradingId"><span>{{ $t("dep_acc_fund_tradAccId") }}</span>{{ list.account_id }}</div>
                            </div>
                        </div>
                        <div class="acntType" v-if="list.demo_live == 1">
                            {{ $t("dash_live") }}
                        </div>
                    </div>
                    <div class="ftr d-flex align-items-center justify-content-between">
                        <div class="accountCurncy">
                            <img
                                :src="'../../../../static/fxView/images/' +
                                list.currency.toLowerCase() +
                                '.svg'
                                "
                                alt="usd"
                            />
                            {{ list.currency }}
                        </div>
                        <div class="acntType" v-if="list.demo_live == 0">
                            {{ $t("dash_demo") }}
                        </div>
                        <div
                            class="depositNow"
                            @click.prevent="
                            account_id = list.account_id;
                        currency_selected = list.currency;
                        amount_msz_error = '';
                        transactionLimitCurrency();
                        "
                        >
                            <a>{{ $t("dep_acc_fund_depFund") }}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="CustomBlockWidth accountList" v-if="shwStep == 2">
                <div class="row justify-content-center">
                    <div class="stepForm middleBox">
                        <div class="whiteBG p-3">
                            <h4 class="mb-3">{{ $t("dep_acc_fund_selDepMet") }}</h4>
                            <div class="form-group d-flex justify-content-start align-items-center field-wrapper mb-3">
                                <ul class="twoColumn flex-wrap justify-content-start depositpaymentMethod w-100">
                                    <!-- && OnlyUsers() (parseInt(key) == 1 && isSACountry()) || -->

                                    <template
                                        class="mb-3 mr-2"
                                        v-for="(list, key) in $env_var.withdrawalMethod"
                                        v-if="(parseInt(key) == 1 && checkPaymentOptionEligibility(1)) ||
                                        (parseInt(key) == 18 && checkPaymentOptionEligibility(18)) ||
                                        parseInt(key) == 23 ||
                                        (parseInt(key) == 24 &&
                                            checkPaymentOptionEligibility(24)) ||
                                        (parseInt(key) == 25 &&
                                            checkPaymentOptionEligibility(25)) ||
                                        (parseInt(key) == 26 &&
                                            checkPaymentOptionEligibility(26)) ||
                                        (parseInt(key) == 27 &&
                                            checkPaymentOptionEligibility(27)) ||
                                        (parseInt(key) == 31 &&
                                            checkPaymentOptionEligibility(31)) ||
                                        (parseInt(key) == 32 &&
                                            checkPaymentOptionEligibility(32)) ||
                                        (parseInt(key) == 33 &&
                                            checkPaymentOptionEligibility(33)) ||
                                        (parseInt(key) == 2 &&
                                            checkPaymentOptionEligibility(2)) ||
                                        (parseInt(key) == 3 &&
                                            checkPaymentOptionEligibility(3)) ||
                                        (parseInt(key) == 5 &&
                                            checkPaymentOptionEligibility(5))
                                        "
                                    >
                                        <!-- {{ astroPayCountryMethods }} -->
                                        <!-- || (parseInt(key) == 18 && parseInt(get_user.verified_status) == 0 ? 'disabled' : '') -->
                                        <!-- && (depositValue[parseInt(key)]=='BTC'? (allow_Crypto_user.includes(get_user.profile.user_id)):true) -->
                                        <li class="mb-3 mr-2 align" :class="(parseInt(get_method_id) == parseInt(key) ? 'selected' : '')" v-if="parseInt(key) != 27 ">
                                            <!-- (parseInt(key) == 24 && 
                                        checkPaymentOptionEligibility(24)) ||  -->
                                            <label class="customRadio-button d-flex justify-content-between align-items-center">
                                                <div class="lft d-flex align-items-center justify-content-start">
                                                    <img
                                                        :src="'../../../../static/fxView/images/' +
                                                        checkPaymentOptionEligibility(key, true)
                                                        "
                                                        alt="Bank Account"
                                                        class="mr-2"
                                                    />
                                                </div>
                                                <div class="rft">
                                                    <input
                                                        type="radio"
                                                        name="radio"
                                                        v-validate="{ required: true }"
                                                        :value="depositValue[parseInt(key)]"
                                                        v-model="pay_option"
                                                        v-on:change="select_option_method(key)"
                                                        :class="{
                                                            'is-invalid': submitted && errors.has('radio'),
                                                        }"
                                                        ref="radioInput"
                                                    />
                                                    <span class="checkmark"></span>
                                                </div>
                                            </label>
                                        </li>
                                        <template v-else-if="astroPayCountryMethods[get_user.profile.residence_country]">
                                            <!-- v-if="pay_code.isAllow && checkPaymentOptionEligibility(27,false,pay_code.code)" -->
                                            <li
                                                class="mb-3 mr-2 flex-column"
                                                v-for="pay_code in astroPayCountryMethods[get_user.profile.residence_country]"
                                                v-if="pay_code.isAllow"
                                                :class="(pay_option === pay_code.code ? 'selected' : '') || (parseInt(key) == 18 && parseInt(get_user.verified_status) == 0 ? 'disabled' : '')"
                                            >
                                                <label class="customRadio-button d-flex justify-content-between align-items-center">
                                                    <div class="lft d-flex align-items-center justify-content-start">
                                                        <img style="height: 70px; object-fit: cover; object-position: top center;" :src="$env_var.astroPayImage.replace('{{PM}}', pay_code.code)" alt="Bank Account" class="mr-2" />
                                                    </div>
                                                    <div class="rft">
                                                        <input
                                                            type="radio"
                                                            name="radio"
                                                            v-validate="{ required: true }"
                                                            :value="pay_code.code"
                                                            v-model="pay_option"
                                                            v-on:change="select_option_method(key)"
                                                            :class="{ 'is-invalid': submitted && errors.has('radio') }"
                                                            ref="radioInput"
                                                        />
                                                        <span class="checkmark"></span>
                                                    </div>
                                                </label>
                                                <span class="method-name f-12 pt-1">{{ pay_code.pay_method }}</span>
                                            </li>
                                        </template>
                                    </template>
                                </ul>
                            </div>
                            <p class="error mb-3" v-if="error in errors.collect('radio')">
                                {{ $t("dep_acc_fund_depFieldReq") }}
                            </p>
                            <div class="clearfix"></div>
                            <!-- <div v-if="parseInt(get_method_id) == 1">
                        <div
                        class="position-relative mb-3"
                        v-if="
                        Object.keys(withdrawalMethodResponse).length > 0 &&
                        withdrawalMethodResponse.hasOwnProperty(1)
                        "
                        >
                        <
                        <h4 class="mb-3">{{ $t("dep_selectbankaccount") }}</h4>
                        <div
                        v-for="(list, index) in withdrawalMethodResponse[
                        parseInt(get_method_id)
                        ]"
                        >
                        <label class="list-group-item bankcard head">
                        <div
                        class="d-flex justify-content-between align-items-center"
                        >
                        <div class="d-flex">
                        <h4 class="pl-3">
                        <span>{{ list.account_no }}</span>
                        </h4>
                        <div class="rft">
                        <input
                        type="radio"
                        id="one"
                        :value="list"
                        v-model="bankData"
                        v-validate="{ required: true }"
                        name="bankData"
                        :class="{
                        'is-invalid':
                        submitted && errors.has('bankData'),
                        }"
                        ref="bankDataInput"
                        />
                        <div class="checkmark"></div>
                        </div>
                        </div>
                        <div>
                        <a
                        href="#"
                        class="green"
                        @click.prevent="detailDiv(index)"
                        v-if="index == showIndex"
                        >{{ $t("dep_acc_fund_lessDet") }}</a
                        >
                        <a
                        href="#"
                        class="green"
                        @click.prevent="detailDiv(index)"
                        v-else
                        >{{ $t("dep_acc_fund_viewDet") }}</a
                        >
                        </div>
                        </div>
                        </label>
                        <div
                        class="personalForm list-group mb-3"
                        :ref="'buttons' + index"
                        v-if="index == showIndex"
                        >
                        <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        >
                        <span class="titleArea">{{
                        $t("dep_holderName")
                        }}</span>
                        <span>{{ list.holder_name }}</span>
                        </div>
                        <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        >
                        <span class="titleArea">{{ $t("prof_bankName") }}</span>
                        <span>{{ list.bank_name }}</span>
                        </div>
                        <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        >
                        <span class="titleArea">{{ $t("prof_bankAdd") }}</span>
                        <span>{{ list.bank_address }}</span>
                        </div>
                        <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        >
                        <span class="titleArea">{{ $t("dep_sortCode") }}</span>
                        <span>{{ list.sort_code }}</span>
                        </div>
                        <div
                        class="list-group-item d-flex justify-content-between align-items-center"
                        >
                        <span class="titleArea">{{ $t("dep_reference") }}</span>
                        <span
                        >{{ $t("dep_fortradaccount") }}{{ account_id }}</span
                        >
                        </div>
                        </div>
                        </div>
                        <ul>
                        <li
                        v-for="error in errors.collect('bankData')"
                        class="error"
                        >
                        {{ $t("dep_selectAcc") }}
                        </li>
                        </ul>
                        </div>
                        <div class="mb-3" v-else>
                        <p>
                        {{ $t("dep_acc_fund_DontbankAcc") }}
                        <router-link
                        :to="{
                        name: 'fxView.support',
                        params: {
                        tabName: 'requestServiceElement',
                        ticketData: '16',
                        account_id: account_id,
                        method_id: get_method_id,
                        },
                        }"
                        >
                        {{ $t("dep_acc_fund_clkHere") }}
                        </router-link>
                        {{ $t("dep_Createbank") }}
                        </p>
                        </div>
                        </div> -->
                            <div v-if="parseInt(get_method_id) == 1">
                                <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                    <div class="list-group-item w-100 d-flex align-items-center justify-content-center">
                                        <span>{{ $t("depMsz1") }}<strong> 1 to 5 working days</strong></span>
                                        <span class="justify-content-end">{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                    </div>
                                </div>
                                <p class="mb-2">Our Bank details are:</p>
                                <div v-for="(list, index) in $env_var.depositBankListDetail" class="mb-3">
                                    <div class="list-group-item head">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p><span>{{ list.region }}</span></p>
                                            </div>
                                            <div>
                                                <a href="#" class="green" @click="detailDiv(index);" v-if="index == showIndex">Less Detail</a>
                                                <a href="#" class="green" @click="detailDiv(index);" v-else>View Detail</a>
                                            </div>
                                        </div>
                                        <div class="border p-2 mt-2 whiteBG w-100 radius">
                                            <p class="mb-0">
                                                <span>Minimum Deposit Amount: <b>{{ list.min_deposit }} </b> </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3" :ref="'buttons' + index" v-if="index == showIndex">
                                        <div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Holder Name:</span> <span>{{ list.account_holder_name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Account Number:</span> <span>{{ list.account_number }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Bank Name:</span> <span>{{ list.Bank_Name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Swift/BIC:</span> <span>{{ list.SWIFT }}</span></div>
                                            <!-- <div class="list-group-item d-flex align-items-center justify-content-center"><span>Sort Code:</span> <span>{{ list.Sort_Code }}</span></div> -->
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>IBAN</span> <span>{{ list.IBAN }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Address:</span> <span>{{ list.address }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center">
                                                <span><b>Reference</b></span> <span><b>For trading account {{ account_id }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 1 && isSACountry()">
                                <div v-for="(list, index) in $env_var.depositBankListDetailFNB" class="mb-3">
                                    <div class="list-group-item head">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p><span>{{ list.region }}</span></p>
                                                <!-- <p>Only ZAR can be received from countries South Africa, Eswatini, Lesotho and Namibia otherwise funds will be returned which can take up to 10 business days</p> -->
                                                <!--                                 <p v-if="list.region == 'Moneynetint'">{{ $t('warnMsz') }}</p> -->
                                                <!--<p v-if="list.Bank_Name == 'Moneynetint'"><span>{{list.region}}</span></p>
                                                    <p>
                                                        <span>{{ $t('bankName') }}</span>  
                                                        <span v-if="list.swift == 'PIRBCY2NXXX'">{{list.Bank_Name}} ({{list.account_currency}})</span>
                                                        <span v-else>{{list.Bank_Name}}</span>
                                                    </p>-->
                                            </div>
                                            <div>
                                                <a href="#" class="green" @click="detailDiv1(index);" v-if="index == showIndex1">Less Detail</a>
                                                <a href="#" class="green" @click="detailDiv1(index);" v-else>View Detail</a>
                                            </div>
                                        </div>
                                        <div class="border p-2 mt-2 whiteBG w-100 radius">
                                            <!--  <p v-if="list.region == 'Moneynetint'">
                                        <span>{{$t('MiniDepositAmount')}}: <b>&euro; 5000 </b> </span>
                                        </p>
                                        -->
                                            <p class="mb-0">
                                                <span>Minimum Deposit Amount: <b>{{ list.min_deposit }} </b> </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3" :ref="'buttons' + index" v-if="index == showIndex1">
                                        <div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Account Number:</span> <span>{{ list.account_number }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Holder Name:</span> <span>{{ list.account_holder_name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Bank Name:</span> <span>{{ list.Bank_Name }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Swift/BIC:</span> <span>{{ list.SWIFT }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center"><span>Address:</span> <span>{{ list.address }}</span></div>
                                            <div class="list-group-item d-flex align-items-center justify-content-center">
                                                <span><b>Reference</b></span> <span><b>For trading account {{ account_id }}</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 5">
                                <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                    <div class="list-group-item w-100">
                                        <span>
                                            {{ $t("dep_acc_fund_MinDepAmt") }}:
                                            <b class="ml-2">
                                                {{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 5 : 50 : checkSuccessDeposit() ? 80 : 800 }}
                                            </b>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-if="parseInt(get_method_id) == 3">
                                <div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>{{ $t("depMsz1") }}<strong>{{ $t("depMsz10") }}</strong></span>
                                            <span>{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>
                                                {{ $t("MiniDepositAmount") }}:
                                                <b>{{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 5 : 50 : checkSuccessDeposit() ? 80 : 800 }} </b>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- <div class="border p-3 radius mb-5"> <div class="col-12 p-0" v-if="withdrawalMethodResponse !=''" > <p class="mb-3">{{$t("netId")}}<strong v-if=" withdrawalMethodResponse.hasOwnProperty( get_method_id ) " >{{withdrawalMethodResponse[get_method_id][0] .online_payment_id}}</strong> <strong v-else>{{get_user.email}}</strong> </p><span>{{$t("depMsz13")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("depMsz14")}}</span> </div></div>-->
                                </div>
                                <!-- <div v-if=" Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(3) " > <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center" > <div class="list-group-item w-100"> <span >{{$t("depMsz1")}}<strong>{{$t("depMsz10")}}</strong></span > <span >{{$t("depMsz3")}}<strong>{{$t("depMsz4")}}</strong></span > </div></div><div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center" > <div class="list-group-item w-100"> <span >{{$t("MiniDepositAmount")}}: <b>&euro; 5 </b></span > </div></div><div class="border p-3 radius mb-5"> <div class="col-12 p-0" v-if="withdrawalMethodResponse !=''" > <p class="mb-3">{{$t("netId")}}<strong v-if=" withdrawalMethodResponse.hasOwnProperty( get_method_id ) " >{{withdrawalMethodResponse[get_method_id][0] .online_payment_id}}</strong> <strong v-else>{{get_user.email}}</strong> </p><span>{{$t("depMsz13")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("depMsz14")}}</span> </div></div></div><div class="mb-3" v-else> <p>{{$t("DntNetteler")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("Tocreate")}}</p></div>-->
                            </div>
                            <div v-if="parseInt(get_method_id) == 2">
                                <div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>{{ $t("depMsz1") }}<strong>{{ $t("depMsz10") }}</strong></span>
                                            <span>{{ $t("depMsz3") }}<strong>{{ $t("depMsz4") }}</strong></span>
                                        </div>
                                    </div>
                                    <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                        <div class="list-group-item w-100">
                                            <span>
                                                {{ $t("MiniDepositAmount") }}:
                                                <b>{{ $env_var.currencyIcon[currency_selected.toUpperCase()] }} {{ (currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 5 : 50 : checkSuccessDeposit() ? 80 : 800 }}</b>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- <div class="border p-3 radius mb-5"> <div class="col-12 p-0" v-if="withdrawalMethodResponse !=''" > <p class="mb-3">{{$t("wit_skrillId")}}<strong v-if=" withdrawalMethodResponse.hasOwnProperty( get_method_id ) " >{{withdrawalMethodResponse[get_method_id][0] .online_payment_id}}</strong ><strong v-else>{{get_user.email}}</strong> </p><span >{{$t("depMsz11")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("depMsz12")}}</span> </div></div>-->
                                </div>
                                <!-- <div v-if=" Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(2) " > <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center" > <div class="list-group-item w-100"> <span >{{$t("depMsz1")}}<strong>{{$t("depMsz10")}}</strong></span > <span >{{$t("depMsz3")}}<strong>{{$t("depMsz4")}}</strong></span > </div></div><div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center" > <div class="list-group-item w-100"> <span >{{$t("MiniDepositAmount")}}: <b>&euro; 5</b></span > </div></div><div class="border p-3 radius mb-5"> <div class="col-12 p-0" v-if="withdrawalMethodResponse !=''" > <p class="mb-3">{{$t("wit_skrillId")}}<strong v-if=" withdrawalMethodResponse.hasOwnProperty( get_method_id ) " >{{withdrawalMethodResponse[get_method_id][0] .online_payment_id}}</strong ><strong v-else>{{get_user.email}}</strong> </p><span >{{$t("depMsz11")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("depMsz12")}}</span> </div></div></div><div class="mb-3" v-else> <p>{{$t("DntSkill")}}<router-link :to="{name: 'fxView.support', params:{tabName: 'requestServiceElement', ticketData: '16', account_id: account_id, method_id: get_method_id,},}" >{{$t("clickHere")}}</router-link >{{$t("Tocreate")}}</p></div>-->
                            </div>
                            <div v-if="parseInt(get_method_id) == 18 && ShowAddress && apiCryptoAddress != ''">
                                <!-- && (parseInt(get_user.profile.user_id) == 641 || parseInt(get_user.profile.user_id) == 510 || parseInt(get_user.profile.user_id) == 10141) -->
                                <div class="position-relative mb-3">
                                    <!-- <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center"><div class="list-group-item w-100"><span class="minSpace">Please select bank : </span></div></div>-->
                                    <h4 class="mb-3">Please Select Currency:</h4>
                                    <div class="customSelectBlock">
                                        <!-- <a @click="currencyTab = !currencyTab" href="javascript:void(0)" class="viewAnker">Select Currency <feather type="chevron-down"></feather></a> -->
                                        <select class="viewAnker" v-model="selectcurrency" name="currency" @change="(getCryptoAddress(selectcurrency), addcrptoCurr = selectcurrency)" v-validate="'required'">
                                            <option value="">Select Currency</option>
                                            <option v-for="(list, index) in crptoJsonNew" :value="list">
                                                {{ handleCryptoList(list) }}
                                                <!-- {{ list }}{{ !['BTC', 'USDT(TRC20)', 'USDC(TRC20)'].includes(list) ? '(ERC20)' : '' }} -->
                                            </option>
                                        </select>
                                    </div>
                                    <ul>
                                        <li v-if="errors.has('currency')" class="error">
                                            {{ errors.first('currency') }}
                                        </li>
                                    </ul>
                                </div>
                                <p v-if="selectcurrency != 'BTC'" class="text-danger">
                                    *Please note that while selecting {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} you send funds via {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} network, if you deposit via any other network your assets may be lost.
                                </p>
                            </div>
                            <div
                                v-if="get_method_id != '' &&
                                parseInt(get_method_id) == 1 &&
                                Object.keys(withdrawalMethodResponse).length > 0 &&
                                withdrawalMethodResponse.hasOwnProperty(1)
                                "
                            >
                                <h4 class="mb-3" v-if="parseInt(get_method_id) != 1">{{ $t("dep_acc_fund_SpeDepAm") }}</h4>
                                <div class="form-group field-wrapper widthCalc" v-if="get_method_id != 1">
                                    <div class="d-flex mob-wrap">
                                        <div class="position-relative Form-Area mr-2">
                                            <input
                                                placeholder="Amount"
                                                type="text"
                                                v-model="amount"
                                                v-validate="{ required: true, numeric: true }"
                                                name="amount"
                                                class="float-field form-control"
                                                :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                ref="amountInput"
                                            />
                                        </div>
                                        <div
                                            class="SpecifyDeposit d-flex justify-content-start align-items-center p-0"
                                            v-if="get_user.profile.residence_country != 'VN' &&
                                                get_user.profile.residence_country != 'ZA' &&
                                                get_user.profile.residence_country != 'ID'
                                                "
                                        >
                                            <div
                                                :class="amount ==
                                                depositLimitCurrencyWise[
                                                currency_selected.toUpperCase()
                                                ] *
                                                n
                                                ? 'customUserType multiSlct mr-2 selected'
                                                : 'customUserType multiSlct mr-2'
                                                "
                                                v-for="n in 3"
                                            >
                                                <label class="customRadio-button border" @click="amount = depositLimitCurrencyWise[currency_selected.toUpperCase()] * n">
                                                    {{ depositLimitCurrencyWise[currency_selected.toUpperCase()] * n }}
                                                    <input
                                                        type="radio"
                                                        name="radio1"
                                                        :value="depositLimitCurrencyWise[
                                                        currency_selected.toUpperCase()
                                                    ] * n
                                                        "
                                                    />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li v-for="error in errors.collect('amount')" class="error">
                                            {{ error }}
                                        </li>
                                    </ul>
                                    <p
                                        class="error"
                                        v-if="amount_msz_error != '' && parseInt(get_method_id) != 16
                                        "
                                    >
                                        {{ amount_msz_error }}
                                    </p>
                                </div>
                            </div>
                            <div v-if="get_method_id != '' && [5, 3, 2, 18, 23, 24, 25, 26, 27, 31, 32, 33].includes(parseInt(get_method_id))">
                                <div v-if="parseInt(get_method_id) == 24">
                                    <div class="row">
                                        <!-- <div class="col-lg-6">
                                            <div class="form-group field-wrapper widthCalc">
                                                <h4 class="mb-3">Please Select Currency:</h4>
                                                <div class="customSelectBlock">
                                                    <select class="viewAnker" v-model="addhelp2payCurr" name="Currency" v-validate="{ required: true}" v-on:change="amount_help2pay();addhelp2payBank = ''">
                                                        <option value="">Select Currency</option>
                                                        <option v-for="(list, index) in getCurrencyCode" :value="list">
                                                            {{list}}
                                                        </option>
                                                    </select>
                                                </div>
                                                <ul>
                                                    <li v-if="errors.has('Currency')" class="error">
                                                        {{errors.first('Currency')}}
                                                    </li>
                                                </ul>
                                            </div>
                                            v-if="addhelp2payCurr"
                                        </div> -->
                                        <div class="col-lg-12">
                                            <div class="form-group field-wrapper widthCalc">
                                                <h4 class="mb-3">Please Select Bank:</h4>
                                                <div class="customSelectBlock">
                                                    <select class="viewAnker" v-model="addhelp2payBank" name="bank" v-validate="'required'">
                                                        <option value="">Select Bank </option>
                                                        <option v-for="(item, index) in getHelp2PayBankList[addhelp2payCurr]" :value="item.id">
                                                            {{ item.value }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <ul>
                                                    <li v-if="errors.has('bank')" class="error">
                                                        {{ errors.first('bank') }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="mb-3">{{ $t("dep_acc_fund_SpeDepAm") }} in <span class="green">{{ currency_selected }}</span></h4>
                                        <div class="form-group field-wrapper widthCalc" v-if="addhelp2payCurr">
                                            <div class="mob-wrap">
                                                <div class="position-relative mr-2">
                                                    <input
                                                        placeholder="Amount"
                                                        type="text"
                                                        v-model="amount"
                                                        v-validate="{ required: true, between: [Math.ceil(amountLimit[addhelp2payCurr].minlength / conversion_unit), parseFloat(amountLimit[addhelp2payCurr].maxlength / conversion_unit).toFixed(2)] }"
                                                        name="amount"
                                                        class="float-field form-control"
                                                        :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                        ref="amountInput"
                                                    />
                                                </div>
                                            </div>
                                            <ul>
                                                <li v-for="error in errors.collect('amount')" class="error">{{ error }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="parseInt(get_method_id) == 31">
                                    <h4 class="mb-3">{{ $t("dep_acc_fund_SpeDepAm") }} in <span class="green">{{ currency_selected }}</span></h4>
                                    <div class="form-group field-wrapper widthCalc">
                                        <div class="mob-wrap">
                                            <div class="position-relative mr-2">
                                                <input
                                                    placeholder="Amount"
                                                    type="text"
                                                    v-model="amount"
                                                    name="amount"
                                                    v-validate="{ required: true, between: [Math.ceil(minAmt), parseFloat(maxAmt)] }"
                                                    class="float-field form-control"
                                                    :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                    ref="amountInput"
                                                />
                                            </div>
                                        </div>
                                        <ul>
                                            <li v-for="error in errors.collect('amount')" class="error">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="parseInt(get_method_id) == 18">
                                    <div v-if="ShowAddress && !apiCryptoAddress">
                                        <div class="form-group field-wrapper widthCalc">
                                            <div class="position-relative Form-Area mr-2 w-100">
                                                <h4 class="mb-2">WITHDRAWAL WALLET ADDRESS</h4>
                                                <input type="text" :value="apiCryptoAddress" class="float-field form-control W-100" v-if="apiCryptoAddress != ''" disabled />
                                                <input
                                                    placeholder=""
                                                    type="text"
                                                    v-model="CryptoAddress"
                                                    v-validate="'required'"
                                                    name="CryptoAddress"
                                                    class="float-field form-control W-100"
                                                    :class="{ 'is-invalid': submitted && errors.has('CryptoAddress'), }"
                                                    ref="CryptoAddressInput"
                                                    v-else
                                                />
                                            </div>
                                            <p v-for="error in errors.collect('CryptoAddress')" class="error">
                                                Enter Crypto Address
                                            </p>
                                        </div>
                                        <!-- v-if="(parseInt(get_user.profile.user_id) == 641 || parseInt(get_user.profile.user_id) == 510 || parseInt(get_user.profile.user_id) == 10141)" -->
                                        <div class="form-group field-wrapper widthCalc">
                                            <h4 class="mb-3">Please Select Currency:</h4>
                                            <!-- <div
                                                v-for="(list, index) in crptoJson"
                                                >
                                                <label class="list-group-item bankcard head">
                                                  <div
                                                    class="d-flex justify-content-between align-items-center"
                                                  >
                                                    <div class="d-flex">
                                                      <h4 class="pl-3">
                                                        <span>{{ list }}</span>
                                                      </h4>
                                                      <div class="rft">
                                                        <input
                                                          type="radio"
                                                          id="one"
                                                          :value="list"
                                                          v-model="addcrptoCurr"
                                                          v-validate="{ required: true }"
                                                          name="currency"
                                                          :class="{
                                                            'is-invalid':
                                                              submitted && errors.has('currency'),
                                                          }"
                                                          ref="currencyInput"
                                                        />
                                                        <div class="checkmark"></div>
                                                      </div>
                                                    </div>

                                                  </div>
                                                </label>
                                                </div> -->
                                            <div class="customSelectBlock">
                                                <!-- <a @click="currencyTab = !currencyTab" href="javascript:void(0)" class="viewAnker">Select Currency <feather type="chevron-down"></feather></a> -->
                                                <select class="viewAnker" v-model="addcrptoCurr" @change="(getCryptoAddress(addcrptoCurr), selectcurrency = addcrptoCurr)" name="currency" v-validate="'required'">
                                                    <option value="">Select Currency</option>
                                                    <option v-for="(list, index) in crptoJsonNew" :value="list">
                                                        {{ handleCryptoList(list) }}
                                                        <!-- {{ list }}{{ !['BTC', 'USDT(TRC20)', 'USDC(TRC20)'].includes(list) ? '(ERC20)' : '' }} -->
                                                    </option>
                                                    <!-- <option v-for="(list, index) in crptoJson" :value="list"> {{ list }}{{ !['BTC', 'USDT(TRC20)', 'USDC(TRC20)'].includes(list) ? '(ERC20)' : '' }}</option> -->
                                                </select>
                                            </div>
                                            <ul>
                                                <li v-if="errors.has('currency')" class="error">
                                                    {{ errors.first('currency') }}
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="form-group field-wrapper widthCalc" v-if="apiCryptoAddress == ''">
                                            <p class="text-danger" v-if="addcrptoCurr && addcrptoCurr != 'BTC'">
                                                *Please note that while selecting {{ !['TRXUSDT', 'TRXUSDC'].includes(addcrptoCurr) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} you send funds via {{ !['TRXUSDT', 'TRXUSDC'].includes(addcrptoCurr) ? 'ERC' : 'TRC' }} network, if you deposit via any other network your assets may be lost.
                                            </p>
                                            <div class="position-relative Form-Area w-100 mb-2 d-flex">
                                                <input type="checkbox" id="clickMe" v-model="clickMe" name="clickMe" v-validate="'required'" ref="clickMeInput" class="mt-2 mr-3" />
                                                <label for="clickMe">
                                                    I confirm, that Crypto wallet address mentioned above, solely belongs to me. I understand and I agree, that future withdrawals transactions will be available only to this Crypto wallet
                                                    address.
                                                </label>
                                            </div>
                                            <p v-for="error in errors.collect('clickMe')" class="error">
                                                Field is Required
                                            </p>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <div class="form-group field-wrapper widthCalc">
                                            <div class="position-relative Form-Area mr-2 w-100">
                                                <h4 class="mb-2">WITHDRAWAL WALLET ADDRESS</h4>
                                                <input type="text" :value="apiCryptoAddress" class="float-field form-control W-100" v-if="apiCryptoAddress != ''" disabled />
                                                <input
                                                    placeholder=""
                                                    type="text"
                                                    v-model="CryptoAddress"
                                                    v-validate="'required'"
                                                    name="CryptoAddress"
                                                    class="float-field form-control W-100"
                                                    :class="{ 'is-invalid': submitted && errors.has('CryptoAddress'), }"
                                                    ref="CryptoAddressInput"
                                                    v-else
                                                />
                                            </div>
                                            <p v-for="error in errors.collect('CryptoAddress')" class="error">
                                                Enter Crypto Address
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="clearfix"></div>
                                <h4 class="mb-3" v-if="![1, 24, 31].includes(parseInt(this.get_method_id))">
                                    {{ $t("dep_acc_fund_SpeDepAm") }} in
                                    <span class="green">{{ currency_selected }}</span>
                                </h4>
                                <div class="form-group widthCalc" v-if="![1, 24, 31].includes(parseInt(this.get_method_id))">
                                    <div v-if="(pay_option == 'IX')">
                                        <b>Amount in BRL :</b> {{ astropayConvertedAmount }}
                                    </div>
                                    <div class="d-flex mob-wrap">
                                        <div class="position-relative Form-Area mr-md-2">
                                            <input
                                                placeholder="Amount"
                                                type="text"
                                                v-model="amount"
                                                v-validate="{ required: true, numeric: true }"
                                                name="amount"
                                                class="float-field form-control"
                                                :class="{ 'is-invalid': submitted && errors.has('amount'), }"
                                                ref="amountInput"
                                                @input="conversionAmount"
                                            />
                                            <!-- @change="conversionAmount" -->
                                        </div>
                                        <div class="SpecifyDeposit d-flex justify-content-start align-items-center p-0">
                                            <div :class="amount == 100 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 100">
                                                    100 <input type="radio" name="radio1" value="100" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 200 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 200">
                                                    200 <input type="radio" name="radio1" value="200" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 500 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 500">
                                                    500 <input type="radio" name="radio1" value="500" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 1000 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 1000">
                                                    1000
                                                    <input type="radio" name="radio1" value="1000" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div :class="amount == 2000 ? 'customUserType multiSlct mr-2 selected' : 'customUserType multiSlct mr-2'" @click="conversionAmount">
                                                <label class="customRadio-button border" @click.prevent="amount = 2000">
                                                    2000
                                                    <input type="radio" name="radio1" value="2000" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <ul>
                                        <li v-for="error in errors.collect('amount')" class="error">
                                            {{ error }}
                                        </li>
                                    </ul>
                                    <!--  && parseInt(get_method_id) != 18 -->
                                    <p class="error" v-if="amount_msz_error != ''">
                                        {{ amount_msz_error }}
                                    </p>
                                </div>
                                <template v-if="pay_option == 'IX'">
                                    <div class="row row-marginmob">
                                        <div class="col-6">
                                            <div class="funding-input pb-3 pb-md-0 Form-Area w-100">
                                                <input
                                                placeholder="Enter your 11 digit CPF"
                                                type="text"
                                                v-model="document"
                                                v-validate="{ required: true, numeric: true, min: 11, max:11 }"
                                                name="document"
                                                class="float-field form-control"
                                                :class="{ 'is-invalid': submitted && errors.has('document'), }"
                                                ref="documentInput"
                                                @input="documentValidation"
                                            />
                                            <p class="error" v-for="error in errors.collect('document')">
                                                {{ error }}
                                            </p>
                                            <p class="error" v-if="doc_error">Invalid CPF Number</p>
                                            </div> 
                                        </div>
                                        <div class="col-6">
                                            <div class="funding-input pb-3 pb-md-0 Form-Area w-100">
                                                <input
                                                    placeholder="Enter your phone number"
                                                    type="text"
                                                    v-model="phone"
                                                    v-validate="{ required: true, numeric: true, min: 11, max:11 }"
                                                    name="phone"
                                                    class="float-field form-control"
                                                    :class="{ 'is-invalid': submitted && errors.has('phone'), }"
                                                    ref="phoneInput"
                                                />
                                                <p class="error" v-for="error in errors.collect('phone')">
                                                    {{ error }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <p v-if="get_method_id != '' && get_method_id != 1 && parseInt(get_user.verified_status) == 1 && parseInt(get_method_id) != 24" class="text-danger">
                                *In order to trade you still need to provide us with a valid Proof of Residence.
                            </p>
                            <div class="clearfix"></div>
                            <div class="bitNotes" v-if="parseInt(get_method_id) == 18">
                                <p>
                                    When you are making your deposit, please keep the following points in mind:
                                </p>
                                <ul class="desText">
                                    <li>
                                        1. All transactions sent in a currency that differs from the currency of your account will be automatically converted according prevailing market price.
                                    </li>
                                    <li>
                                        2. Please deposit only through Fxview portal. Any direct deposit from your Bitcoin wallet with previously generated invoices will not be processed. Fxview bears no responsibility in such cases.
                                    </li>
                                    <li>
                                        3. Withdrawals will be returned to the same crypto wallet address you have shared with us.
                                    </li>
                                    <li>
                                        4. For deposits/withdrawal amounts higher than 50000 USD, you might be requested to provide us additional documents for verification of funds.
                                    </li>
                                    <li>
                                        5.After making a transaction, please save your hash ID so that your funds can be easily located if needed.
                                    </li>
                                </ul>
                            </div>
                            <p class="error" v-if="raised_max_limit_msg != ''">
                                {{ raised_max_limit_msg }}
                            </p>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center" v-if="parseInt(get_method_id) != 1">
                                <a
                                    class="d-flex align-items-center"
                                    href="#"
                                    v-on:click.stop.prevent="reset(); shwStep = 1;"
                                >
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <!-- <button
                                    class="prism_btn btn_sm"
                                    v-on:click.stop.prevent="validateValue()"
                                    :class="disabledProced ? 'disabled' : ''"
                                    v-if="
                                      get_method_id != '' &&
                                      ((parseInt(get_method_id) == 1 &&
                                        Object.keys(withdrawalMethodResponse).length > 0 &&
                                        withdrawalMethodResponse.hasOwnProperty(1)) ||
                                        parseInt(get_method_id) == 3 ||
                                        parseInt(get_method_id) == 2 ||
                                        parseInt(get_method_id) == 18 ||
                                        parseInt(get_method_id) == 23 ||
                                        parseInt(get_method_id) == 25 ||
                                        (parseInt(get_method_id) != 1 &&
                                          parseInt(get_method_id) != 3 &&
                                          parseInt(get_method_id) != 2))
                                    " 
                                    >
                                    {{ $t("dep_acc_fund_procToPay") }}
                                    </button> -->
                                <button
                                    class="prism_btn btn_sm"
                                    v-on:click.stop.prevent="validateValue()"
                                    :class="disabledProced ? 'disabled' : ''"
                                    v-if="get_method_id != '' && ((parseInt(get_method_id) == 1 && Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(1)) || parseInt(get_method_id) == 3 || parseInt(get_method_id) == 2 || parseInt(get_method_id) == 18 || parseInt(get_method_id) == 23 || parseInt(get_method_id) == 24 || parseInt(get_method_id) == 25 || parseInt(get_method_id) == 26 || parseInt(get_method_id) == 27 || parseInt(get_method_id) == 31 || parseInt(get_method_id) == 32 || (parseInt(get_method_id) != 1 && parseInt(get_method_id) != 3 && parseInt(get_method_id) != 2))"
                                >
                                    <!--parseInt(get_method_id)==17 ||-->
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- {{increaseDepositLimit}} -->
            <div class="costompopup pop_xs fundNow1 DemoCustom" v-if="increaseDepositLimit">
                <div class="whiteBG costompopupBox">
                    <div class="modal-header border-0 pt-3 pl-3 position-relative">
                        <h3 class="modal-title" v-if="trans_id == ''">
                            Your Deposit Limit is{{ get_user.crypto_limit }}
                        </h3>
                        <button type="button" class="close" @click.prevent="increaseDepositLimit = false; trans_id = '';">
                            &times;
                        </button>
                    </div>
                    <div class="modal-body p-3">
                        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                        <div class="mt-2 middleBox" v-if="trans_id != ''">
                            <app-OptVerfication :transaction_id="trans_id" :module="''" :title_parent="0" :data="''" :ticketRequestFrom="'increase-Limit'" :accountId="''"></app-OptVerfication>
                        </div>
                        <div class="text-center" v-else>
                            <p>Do you Want to increase your Deposit Limit</p>
                            <div class="text-center pt-3 mb-3">
                                <a href="#" class="prism_btn btn_xs" @click.prevent="IncreaseLimitOtp()">Yes</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="" v-if="shwStep == 3">
                <app-opt-verfication :transaction_id="trans_id" :module="'120'" :title_parent="'0'" :data="''" :ticketRequestFrom="'bankDeposit'" :accountId="account_id" v-if="trans_id != '' && !congModule"></app-opt-verfication>
                <div class="mt-2" v-if="congModule">
                    <div class="row no-gutters justify-content-center">
                        <div class="whiteBG p-4 middleBox">
                            <div class="congratulations">
                                <div class="logo_congrats">
                                    <img src="../../../../static/fxView/images/congrats.png" alt="Icon" />
                                </div>
                                <div class="subtitle">
                                    <h3>{{ $t("rb_congo") }}<span class="green">{{ get_user.username }}</span></h3>
                                    <p>{{ $t("dep_ticketHasbeenCreated") }}</p>
                                </div>
                            </div>
                            <div class="signupbtn full-width submitButton w-100 mt-4 text-center">
                                <router-link
                                    :to="{
                                    name: 'fxView.support',
                                    params: { tabName: 'openRequest' },
                                }"
                                    class="prism_btn btn_sm"
                                >
                                    {{ $t("dep_proMsz19") }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <form action="https://pay.skrill.com" method="post" target="_self" id="skrillForm">
                <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 7">
                    <div class="confirmPayment">
                        <h3 class="mb-3">{{ $t("PleaseEnsureCorrect") }}</h3>
                        <div class="table-responsive">
                            <table class="table w-100 mb-5">
                                <thead>
                                    <tr>
                                        <th>{{ $t("accountId") }}</th>
                                        <th>{{ $t("feeUsd") }}</th>
                                        <th>{{ $t("depositAmount") }}</th>
                                        <th>{{ $t("paymentMethod") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{ account_id }}</td>
                                        <td>0</td>
                                        <td>{{ amount }}</td>
                                        <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                        </div>
                    </div>
                    <input type="hidden" name="pay_to_email" value="backoffice@fxview.com" />
                    <input type="hidden" name="pay_from_email" :value="get_user.email" />
                    <input type="hidden" name="status_url" value="https://globaltps.fxview.com/payment/resp" />
                    <input type="hidden" name="return_url" :value="$env_var.depositLink" />
                    <input type="hidden" name="firstname" :value="get_user.profile.firstname" />
                    <input type="hidden" name="lastname" :value="get_user.profile.lastname" />
                    <!-- <input type="hidden" name="merchant_id" value="169238422" /> -->
                    <!-- Old merchant id  -->
                    <input type="hidden" name="merchant_id" value="210278473" />
                    <!-- New merchant id  -->
                    <input type="hidden" name="language" value="EN" />
                    <input type="hidden" name="amount" :value="amount" />
                    <input type="hidden" name="currency" :value="currency_selected" />
                    <input type="hidden" name="payment_methods" :value="pay_option" />
                    <input type="hidden" name="email" :value="get_user.email" />
                    <input type="hidden" name="merchant_fields" value="tradingAccount,email,method_id" />
                    <input type="hidden" name="tradingAccount" :value="account_id" />
                    <input type="hidden" name="method_id" :value="get_method_id" />
                    <input type="hidden" name="return_url_target" value="3" />
                    <input type="hidden" name="cancel_url_target" value="3" />
                    <input type="hidden" name="transaction_id" :value="transaction_id" />
                    <input type="hidden" name="detail1_description" :value="'Deposit in ' + account_id" />
                    <input type="hidden" name="detail1_text" value="Payment for account id" />
                    <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                        <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                            <feather class="mr-1" type="chevron-left"></feather>
                            {{ $t("backToStep") }}
                        </a>
                        <button class="prism_btn btn_sm" v-on:click.stop.prevent="getTransactionId()">
                            {{ $t("procToPay") }}
                        </button>
                    </div>
                </div>
            </form>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 6">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">{{ $t("depMsz15") }}</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-5">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="getTransactionId()">
                        {{ $t("procToPay") }}
                    </button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 8">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">{{ $t("depMsz15") }}</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-5">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="getUrlForPraxis()">
                        {{ $t("procToPay") }}
                    </button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 15">
                <div class="confirmPayment">
                    <h3 class="mb-3">{{ $t("conPay") }}</h3>
                    <p class="mb-5">
                        Please ensure that the deposit details are correct and click the ‘Pay Now’ button to make a deposit. Please be aware that converted amount in USD/EUR/AUD/GBP can vary based upon the prevailing {{
                        cryptoConfJson[selectcurrency] }} market price.
                    </p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-2">
                            <thead>
                                <tr>
                                    <th>{{ $t("accountId") }}</th>
                                    <th>{{ $t("feeUsd") }}</th>
                                    <th>{{ $t("depositAmount") }}</th>
                                    <th>{{ $t("paymentMethod") }}</th>
                                    <th>{{ currencyObject[selectcurrency] }} Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ account_id }}</td>
                                    <td>0</td>
                                    <td>{{ amount }}</td>
                                    <td>{{ selectcurrency }}</td>
                                    <!-- $env_var.depositMethodShow[get_method_id] -->
                                    <td>{{ bitcoinConversionData.converted_amount }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="text-danger" v-if="selectcurrency != 'BTC'">
                            *Please note that while selecting {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} you send funds via {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} network, if you deposit via any other network your assets may be lost.
                        </p>
                        <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                    <button class="prism_btn btn_sm" @click="cryptDepositFunc()">
                        Pay Now
                    </button>
                </div>
            </div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show="shwStep == 16">
                <div class="stepForm middleBox">
                    <div class="whiteBG p-3">
                        <h2 class="d-flex justify-content-center p-3">
                            {{ currencyObject[selectcurrency] }} Address
                        </h2>
                        <div class="d-flex justify-content-center p-3 qr-CodeImage">
                            <vue-qrcode :value="cryptoDepositAddress" />
                        </div>
                        <div class="alert text-center pt-3 CouponCode d-flex justify-content-center">
                            <div class="copied" v-if="copyText == cryptoDepositAddress">
                                <p>{{ showcopymsz }}</p>
                            </div>
                            <p class="cyrptAddress d-flex">
                                <span class="float-left cyrptTitle">{{ cryptoDepositAddress }}</span>
                                <span class="copyIcon" v-clipboard:copy="cryptoDepositAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                    <feather type="copy"></feather>
                                </span>
                            </p>
                        </div>
                        <div class="box_space text-center p-4">
                            <div class="deposit_lastsec text-left">
                                <div class="crypto_addsec text-center">
                                    <h3>
                                        Send only {{ currencyObject[selectcurrency] }} to this deposit address
                                    </h3>
                                    <p>
                                        We will auto deposit it in your trading account
                                        <strong>{{ account_id }}</strong> once we receive money
                                    </p>
                                    <p class="text-danger" v-if="selectcurrency != 'BTC'">
                                        *Please note that while selecting {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} you send funds via {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} network, if you deposit via any other network your assets may be lost.
                                    </p>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="backQr()">
                        <feather class="mr-1" type="chevron-left"></feather>
                        {{ $t("backToStep") }}
                    </a>
                </div>
            </div>
            <div class="CustomBlockWidth" v-show="shwStep == 5">
                <div class="row justify-content-center">
                    <div class="middleBox">
                        <div class="whiteBG p-3">
                            <div class="confirmPayment">
                                <h3 class="mb-3">{{ $t("dep_acc_fund_PlsEnsCort") }}</h3>
                                <div class="table-responsive">
                                    <table class="table w-100 mb-5">
                                        <thead>
                                            <tr>
                                                <th>{{ $t("dep_acc_fund_accountId") }}</th>
                                                <th>{{ $t("dep_acc_fund_feeUsd") }}</th>
                                                <th>{{ $t("dep_acc_fund_depAmt") }}</th>
                                                <th>{{ $t("dep_acc_fund_depMeth") }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{{ account_id }}</td>
                                                <td>0</td>
                                                <td>{{ amount }}</td>
                                                <td>{{ $env_var.depositMethodShow[get_method_id] }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                                </div>
                            </div>
                            <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                                <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep = 2">
                                    <feather class="mr-1" type="chevron-left"></feather>
                                    {{ $t("dep_acc_fund_bakStp") }}
                                </a>
                                <button class="prism_btn btn_sm" @click.prevent="creditCardDepositFunc()">
                                    {{ $t("dep_acc_fund_procToPay") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="loaderOverlayFull" v-if="qr_image">
                <div class="loaderContent">
                    <div style="margin-bottom: 20px;">
                        <div class="addressBox d-flex align-items-center flex-column flex-md-row justify-content-between">
                            <strong class="mr-md-3 mb-2 mb-md-0">{{ qr }}</strong>
                            <div class="btn-wrap">
                                <button class="copy prism_btn btn_sm" type="button" @click="copy(qr)">Copy</button>
                                <p class="copytext" v-show="copyMsg != ''">{{ copyMsg }}</p>
                            </div>
                        </div>
                        <img :src="'data:image/png;base64,' + qr_image" />
                    </div>
                    <button type="button" class="prism_btn btn_sm" @click="qr_image = null; copyMsg = ''; astropayConvertedAmount = ''">
                        Done
                    </button>
                </div>
            </div>
        </div>
        <div v-else-if="tradingAccountList.totalLiveAccounts == 0">
            <div class="mainTitle text-center my-3">
                <h3>{{ $t("dep_acc_fund_noTrdAccFnd") }}</h3>
            </div>
            <no-trading-account :demo_live_both="''" :totalRecords="tradingAccountList.totalLiveAccounts"></no-trading-account>
        </div>
        <div class="row d-flex justify-content-center" v-if="shwStep == -4">
            <div class="stepForm middleBox">
                <div class="whiteBG p-3">
                    <h2 class="d-flex justify-content-center p-3">
                        {{ currencyObject[selectcurrency] }} Address
                    </h2>
                    <div class="d-flex justify-content-center p-3 qr-CodeImage">
                        <vue-qrcode :value="cyrptAddress" />
                    </div>
                    <div class="alert text-center pt-3 CouponCode d-flex justify-content-center">
                        <div class="copied" v-if="copyText == cyrptAddress">
                            <p>{{ showcopymsz }}</p>
                        </div>
                        <p class="cyrptAddress d-flex">
                            <span class="float-left cyrptTitle">{{ cyrptAddress }}</span>
                            <span class="copyIcon" v-clipboard:copy="cyrptAddress" v-clipboard:success="onCopy" v-clipboard:error="onError">
                                <feather type="copy"></feather>
                            </span>
                        </p>
                    </div>
                    <div class="box_space text-center p-4">
                        <div class="deposit_lastsec text-center">
                            <div class="crypto_addsec text-center">
                                <h3>
                                    Send only {{ currencyObject[selectcurrency] }} to this deposit address
                                </h3>
                                <p>
                                    We will auto deposit it in your trading account
                                    <strong>{{ account_id }}</strong> once we receive money
                                </p>
                                <p class="text-danger" v-if="selectcurrency != 'BTC'">
                                    *Please note that while selecting {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'USDT(ERC20), ETH(ERC20), USDC(ERC20)' : 'USDT(TRC20), USDC(TRC20)' }} you send funds via {{ !['TRXUSDT', 'TRXUSDC'].includes(selectcurrency) ? 'ERC' : 'TRC' }} network, if you deposit via any other network your assets may be lost.
                                </p>
                                <p v-if="get_method_id != '' && parseInt(get_user.verified_status) == 1" class="text-danger">*In order to trade you still need to provide us with a valid Proof of Residence.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- <div v-html="nuveiData"></div> -->
        <!-- {{help2payFormData}} v-if="nuveiData" -->
        <!-- <div v-html="help2payFormData"></div>
        <div class="costompopup DemoCustom" v-show="help2payFormData">
            <div class="whiteBG costompopupBox">
            <div class="modal-header border-0 pt-3 pl-3 position-relative">
                <h3 class="modal-title">Help2Pay</h3>
                <button type="button" class="close" @click.prevent="help2payFormData = '' ">&times;</button> 
            </div>
            <div class="modal-body p-3">
                <div v-html="help2payFormData"></div>
            </div>
            </div>
        </div> -->
    </div>
    <!-- <div v-else>
        <div id="ruk">
            hekllo
            <div v-html="nuveiData"></div>
        </div>
    </div> -->
</template>

<script>
    // import VueQrcode from 'vue-qrcode'
    import { fxViewMixins } from "@/plugins/fxView";
    import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
    import optVerfication from "../supports/services/otp_verification";
    import moment from "moment";
    import VueQrcode from "vue-qrcode";
    import * as types from "@/types";
    import { mapActions } from "vuex";
    import axios from "axios";

    export default {
        name: "Deposit",
        mixins: [fxViewMixins],
        data() {
            return {
                allow_Crypto_user:[1173],
                PaymentMethodList: [],
                //============message and loader ===========
                qr_image: null,
                qr: null,
                copyMsg: "",
                response_msg: "",
                msg_type: "",
                doc_error: "",
                pageLoader: false,
                currencyTab: false,
                loaderFuncRun: "1",
                //==========================================
                currencyList: "",
                // help2payFormData: "",
                account_id: "",
                act_account_id: "",
                amount: "",
                document: "",
                countrycode: "+55",
                phone: "",
                document_type: "CPF",
                conversion_unit: 1,
                submitted: false,
                shwOption: true,
                shwStep: 1,
                account_number: "",
                pay_option: "",
                description: "Payment for account id",
                get_method_id: "",
                currency_selected: "",
                method_id: "",
                transaction_id: "-1",
                showIndex: "-1",
                showIndex1: "1",
                crptoJson: {
                    "1": "BTC",
                    "2": "USDT",
                    "3": "ETH",
                    "4": "USDC",
                },
                crptoJsonNew: {
                    "1": "BTC",
                    "2": "USDT",
                    "3": "ETH",
                    "4": "USDC",
                    "5": "TRXUSDT",
                    "6": "TRXUSDC",
                },
                selectcurrency: "BTC",
                addcrptoCurr: "",
                disabledProced: false,

                responseTransLimitDataNew: {
                    1: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    2: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    3: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    4: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    5: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    6: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    7: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    8: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    17: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    18: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    23: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    25: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    24: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    26: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    27: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    31: { MONTHLY: "25000", DAILY: "50000", PERTXN: "50000" },
                    32: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                    33: { MONTHLY: "25000", DAILY: "15000", PERTXN: "5000" },
                },
                MinValue: "",
                depositMinAllowedValue: {
                    1: { min_amount: 500 },
                    2: { min_amount: 5 },
                    3: { min_amount: 5 },
                    5: { min_amount: 5 },
                    6: { min_amount: 5 },
                    7: { min_amount: 5 },
                    8: { min_amount: 5 },
                    9: { min_amount: 5 },
                    10: { min_amount: 5 },
                    17: { min_amount: 5 },
                    18: { min_amount: 5 },
                    25: { min_amount: 5 },
                    24: { min_amount: 5 },
                    26: { min_amount: 5 },
                    27: { min_amount: 50 },
                    31: { min_amount: 50 },
                    32: { min_amount: 5 },
                    33: { min_amount: 5 },
                },
                cryptoConfJson: {
                    BTC: "BTCUSD",
                    USDT: "USDTUSD",
                    ETH: "ETHUSD",
                    USDC: "USDCUSD",
                },

                // trans_id: '',
                increaseDepositLimit: false,

                copy_msg1: false,

                cryptoDepositAddress: "",
                cyrptAddress: "",
                cryptoMethods: {
                    BTC: "18",
                    LTC: "19",
                    BCH: "20",
                },
                currencyObject: {
                    BTC: "Bitcoin",
                    LTC: "LiteCoin",
                    BCH: "Bitcoin Cash",
                    USDT: "USDT",
                    ETH: "Etherum",
                    USDC: "USDC",
                    /*"ETH": "Etherum (ETH Network)",
                "TUSD": "True USD (ETH Network)",
                "USDC": "USDC (ETH Network)",
                "ALGO": "Algorand",
                "REP": "Augur",
                "bat": "Basic Attention Token",
                "BSV": "Bitcoin SV",
                "LINK": "Chainlink",
                "BNT": "Bancor",
                "COMP": "Compound",
                "cro": "Crypto.com Coin",
                "USDT": "Tether (ERC 20 Address)",
                "dai": "DAI",
                "enj": "Enjin Coin",
                "eos": "EOS",
                "ZIL": "zilliqa",
                "UNI": "Uniswap"*/
                },
                addhelp2payCurr: "",
                addhelp2payBank: "",
                getCurrencyCode: {
                    THB: "THB",
                    MYR: "MYR",
                    IDR: "IDR",
                    VND: "VND",
                    PHP: "PHP",
                    USD: "USD",
                },

                raised_max_limit_msg: "",
                amount_msz_error: "",

                dp_mtd_show_acc_User_res_con: {
                    SE: [8, 9],
                    DE: [6, 8, 10],
                    PL: [7, 8],
                    BE: [8, 10],
                    IT: [8, 10],
                    NL: [8, 10],
                    ES: [8, 10],
                    AT: [8, 10],
                    BG: [8],
                    DK: [8],
                    EE: [8],
                    FI: [8],
                    FR: [8],
                    GR: [8],
                    HU: [8],
                    LV: [8],
                    PT: [8],
                    NO: [8],
                },

                depositValue: {
                    1: "1",
                    2: "WLT",
                    3: "NTL",
                    5: "CC",
                    6: "GIR",
                    7: "PWY",
                    8: "OBT",
                    9: "EBT",
                    10: "SFT",
                    17: "17",
                    18: "BTC",
                    23: "Paysafe",
                    25: "Swiffy",
                    24: "Help2Pay",
                    26: "Payguru",
                    27: "AstroPay",
                    31: "PerfectMoney",
                    32: "Nuvei",
                    33: "TrustPay",
                },

                bankData: "",
                trans_id: "",
                congModule: false,

                depositLimitCurrencyWise: {
                    AUD: 500,
                    GBP: 500,
                    EUR: 500,
                    USD: 500,
                    ZAR: 500,
                },
                limit: 5,
                payment_method_acc_to_country: {
                    VN: "fxview-bank-vn-d",
                    ZA: "fxview-ozow-za-d",
                    ID: "fxview-bank-id-d",
                },
                SACountries: ["ZA", "LS", "NA"],

                copyText: "",
                showcopymsz: "",
                bitcoinConversionData: {},
                depositCurrency: "",
                apiCryptoAddress: "",
                CryptoAddress: "",
                ShowAddress: false,
                clickMe: false,
                userCountry: "N/A",
                astroPayID: "",
                astropayConvertedAmount: '',
                timeout: null,
                error:'',
                // nuveiData: '',
                //v-if="getUserProfile.residence_country == 'PL'"
            };
        },
        components: {
            appOptVerfication: optVerfication,
            VueQrcode,
        },
        computed: {
            minAmt() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})["USD"] || 1;
                return parseFloat(this.depositMinAllowedValue[this.get_method_id].min_amount / this.conversion_unit).toFixed(2);
            },
            maxAmt() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})["USD"] || 1;
                return parseInt(this.responseTransLimitDataNew[this.get_method_id].DAILY / this.conversion_unit).toFixed(2);
            },
        },
        watch: {
            get_method_id: function (val) {
                if ([5, 3, 2, 17, 18, 23, 24, 25, 26, 27, 31, 32, 33].includes(parseInt(this.get_method_id))) {
                    this.amount_msz_error = "";
                    if (parseInt(this.responseTransLimitDataNew[parseInt(this.get_method_id)].MONTHLY) == 0) {
                        this.raised_max_limit_msg = this.$t("dep_maxlimit");
                        this.disabledProced = true;
                    } else {
                        this.raised_max_limit_msg = "";
                        if (this.responseTransLimitDataNew[parseInt(this.get_method_id)].DAILY < this.responseTransLimitDataNew[parseInt(this.get_method_id)].PERTXN) {
                            this.MinValue = this.responseTransLimitDataNew[parseInt(this.get_method_id)].DAILY;
                        } else {
                            this.MinValue = this.responseTransLimitDataNew[parseInt(this.get_method_id)].PERTXN;
                        }
                        this.disabledProced = false;
                    }
                } else if (parseInt(this.get_method_id) == 1) {
                    if (this.get_user.profile.residence_country != "VN" && this.get_user.profile.residence_country != "ZA" && this.get_user.profile.residence_country != "ID") {
                        if (parseFloat(this.amount) >= this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            this.amount_msz_error = "";
                        }
                    } else if (this.get_user.profile.residence_country == "VN" || this.get_user.profile.residence_country == "ZA" || this.get_user.profile.residence_country == "ID") {
                        if (parseFloat(this.amount) >= this.limit) {
                            this.amount_msz_error = "";
                        }
                    }
                }
            },
            amount: function (val) {
                if (this.checkSuccessDeposit()) {
                    if (parseInt(this.get_method_id) == 1 && this.get_user.profile.residence_country != "VN" && this.get_user.profile.residence_country != "ZA" && this.get_user.profile.residence_country != "ID") {
                        if (parseFloat(this.amount) >= this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            this.amount_msz_error = "";
                        } else if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()] + " " + this.currency_selected;
                        }
                    } else if (parseInt(this.get_method_id) == 1 && (this.get_user.profile.residence_country == "VN" || this.get_user.profile.residence_country == "ZA" || this.get_user.profile.residence_country == "ID")) {
                        if (this.currency_selected.toUpperCase() == "ZAR") {
                            this.limit = 80;
                        } else {
                            this.limit = 5;
                        }
                        if (parseFloat(this.amount) >= this.limit) {
                            this.amount_msz_error = "";
                        } else if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.limit) {
                            if (this.currency_selected.toUpperCase() == "ZAR") {
                                this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 80 + " " + this.currency_selected;
                            } else {
                                this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 5 + " " + this.currency_selected;
                            }
                        }
                    }
                } else if (![24, 27].includes(parseInt(this.get_method_id))) {
                    if (this.currency_selected.toUpperCase() == "ZAR") {
                        if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 800) {
                            this.amount_msz_error = this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                        }
                    } else {
                        if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 50) {
                            this.amount_msz_error = this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                        }
                    }
                }
            },
        },
        methods: {
            getCryptoAddress(val) {
                this.apiCryptoAddress = "";
                // let list = this.PaymentMethodList.data.data;
                let list = this.withdrawalMethodResponse[18];
                
                
                let sorted = list.find((res) => res.last_digit_card == val);
                if (sorted) {
                    
                    this.apiCryptoAddress = sorted.online_payment_id;
                } else {
                    this.apiCryptoAddress = "";
                    // this.select_option_method('18')
                }
                return this.apiCryptoAddress;
            },
            ...mapActions({
                _runGetUserIp: types.RUN_GET_USER_IP,
            }),
            copy(data) {
                try {
                    navigator.clipboard.writeText(data);
                    this.copyMsg = "Copied";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                } catch (e) {
                    this.copyMsg = "Unable to copy";
                    setTimeout(() => {
                        this.copyMsg = "";
                    }, 3000);
                }
            },
            amount_help2pay() {
                this.conversion_unit = (this.convertedCurrencies[this.currency_selected] || {})[this.addhelp2payCurr] || 1;
                this.MinValue = parseFloat(this.amountLimit[this.addhelp2payCurr].maxlength / this.conversion_unit).toFixed(2);
            },
            isSACountry() {
                if (this.get_user.profile && this.get_user.profile.residence_country) {
                    if (this.SACountries.includes(this.get_user.profile.residence_country)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            OnlyUsers() {
                const getuser = [12832, 1173, 4884].includes(this.get_user.profile.user_id);
                return getuser;
            },
            handleCryptoList(list) {
                let out = list;
                if(!['BTC', 'TRXUSDT', 'TRXUSDC'].includes(list)) {
                    out += '(ERC20)';
                } else if (['TRXUSDT'].includes(list)) {
                    out = 'USDT(TRC20)';
                } else if (['TRXUSDC'].includes(list)) {
                    out = 'USDC(TRC20)';
                } else {
                    out = list;
                }
                return out;
            },
            checkSuccessDeposit() {
                if (this.depositList.totalRecords) {
                    let data = this.depositList.records.filter((val) => parseInt(val.payment_status) == 1);
                    if (data.length > 0) {
                        return true;
                    } else {
                        return false;
                    }
                }
            },
            checkPaymentOptionEligibility(option, imageCheck, pay_code) {
                let countries = this.$env_var.paymentOptionsForCountry['"' + this.get_user.profile.residence_country.toString() + '"'];
                if (countries) {
                    if (imageCheck) {
                        if (option == 5) {
                            let key1 = '"Ecommpay MC"';
                            let key2 = '"Ecommpay Visa"';
                            if (countries[key1] && countries[key2]) return "CreditCard.svg";
                            if (countries[key1]) return "mastercard.svg";
                            if (countries[key2]) return "visa.svg";
                        } else {
                            return this.$env_var.withdrawalMethod[`${option}`];
                        }
                    } else {
                        if (option == "2") {
                            let key = '"Skrill"';
                            return countries[key];
                        } else if (option == "1") {
                            let key = '"Banking (Kopayments)"';
                            return countries[key];
                        } else if (option == "3") {
                            let key = '"Neteller"';
                            return countries[key];
                        } else if (option == "18") {
                            let key = '"Cryptos"';
                            return countries[key];
                        } else if (option == "24") {
                            let key = '"Help2Pay"';
                            return countries[key] /* && [12832,12829,1173].includes(this.get_user.profile.user_id)*/;
                        } else if (option == "26") {
                            let key = '"Payguru"';
                            return countries[key];
                        } else if (option == "27") {
                            let key = '"AstroPay"';
                            return countries[key];
                        } else if (option == "31") {
                            let key = '"PerfectMoney"';
                            return countries[key] /* true   && [12832, 12829, 1173, 95].includes(this.get_user.profile.user_id)*/;
                        } else if (option == "32") {
                            let key = '"Nuvei"';
                            return true  && [12832, 12829, 1173].includes(this.get_user.profile.user_id);
                        } else if (option == "33") {
                            let key = '"TrustPay"';
                            return countries[key] && [12832, 12829, 1173, 17562, 11846].includes(this.get_user.profile.user_id);
                        } else if (option == "5") {
                            let key1 = '"Ecommpay MC"';
                            let key2 = '"Ecommpay Visa"';
                            if (countries[key1] || countries[key2]) {
                                return true;
                            } else {
                                return false;
                            }
                        } else if (option == "17") {
                            let key1 = '"Gatech"';
                            // let key2 = '"Payguru"';
                            let key3 = '"Payguru EFTs"';
                            let key4 = '"Payguru Mpesa"';
                            let key5 = '"PayRetailers"';
                            if (
                                countries[key1] ||
                                // countries[key2] ||
                                countries[key3] ||
                                countries[key4] ||
                                countries[key5]
                            ) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                } else if (option == "1") {
                    if (imageCheck) {
                        return this.$env_var.withdrawalMethod[`${option}`];
                    } else {
                        let key = '"Banking (Kopayments)"';
                        return countries ? countries[key] : true;
                    }
                } else if (option == "18") {
                    if (imageCheck) {
                        return this.$env_var.withdrawalMethod[`${option}`];
                    } else {
                        let key = '"Cryptos"';
                        return countries ? countries[key] : true;
                    }
                } else {
                    if (imageCheck) {
                        if (option == 5) {
                            return "CreditCard.svg";
                        } else {
                            return this.$env_var.withdrawalMethod[`${option}`];
                        }
                    } else {
                        return false;
                    }
                }
            },
            backQr() {
                this.shwStep = 2;
                this.get_method_id = "";
                this.bitcoinConversionData = {};
                this.amount = "";
                this.depositCurrency = "";
                this.apiCryptoAddress = "";
                this.CryptoAddress = "";
                this.ShowAddress = false;
                this.clickMe = false;
                this.pay_option = "";
            },
            IncreaseLimitOtp() {
                let jsonData = {
                    globalParams: {
                        reason: 193,
                        reason_text: "Increase Crypto Limit",
                        subject: "Increase crypto deposit limit",
                        text: "kindly increase my crypto deposit limit",
                        /*"title": 0,
                    "title_text": "Increase Crypto Limit"*/
                    },
                    localParams: {
                        parameter: this,
                        type: "increase-limit",
                    },
                };
                this._runTicketRequestOtp(jsonData);
            },
            onCopy(e) {
                var _that = this;
                _that.copyText = e.text;
                if (_that.copyText) {
                    _that.showcopymsz = "Copied";
                }
                setTimeout(function () {
                    _that.showcopymsz = "";
                    _that.copyText = "";
                }, 5000);
            },
            onError(e) {
                var _that = this;
                try {
                    _that.showcopymsz = "Unable to Copy";
                    setTimeout(function () {
                        _that.showcopymsz = "";
                        _that.copyText = "";
                    }, 5000);
                } catch (e) {}
            },
            copytoclipboard(textToCopy) {
                var copyText = textToCopy;

                /* Copy the text inside the text field */
                navigator.clipboard.writeText(copyText);
            },
            getUrlForPraxis() {
                let input_json = {
                    globalParams: {
                        currency: this.currency_selected,
                        amount: this.amount,
                        account_id: this.account_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runPraxisUrl(input_json);
            },
            transactionLimitCurrency() {
                let input_json = {
                    globalParams: {
                        currency: this.currency_selected,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runTransactionLimitCurrency(input_json);
            },
            detailDiv(index) {
                if (this.showIndex == index) {
                    this.showIndex = "-1";
                } else {
                    this.showIndex = index;
                }
            },
            detailDiv1(index) {
                if (this.showIndex1 == index) {
                    this.showIndex1 = "1";
                } else {
                    this.showIndex1 = index;
                }
            },
            select_option_method(getData) {
                this.get_method_id = getData;
                if (parseInt(getData) == 18) {
                    this.depositCurrency = "";
                    this.apiCryptoAddress = "";
                    this.CryptoAddress = "";
                    this.ShowAddress = false;
                    this.clickMe = false;
                    this.changeCrypto("BTC");
                } else if (getData == "24") {
                    this.addhelp2payCurr = this.countryCurrency[this.get_user.profile.residence_country.toString()];
                    this.amount_help2pay();
                }
            },
            creditCardDepositFunc() {
                let input_json = {
                    globalParams: {
                        amount: this.amount,
                        currency: this.currency_selected,
                        account_id: this.account_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runCreditCardDeposit(input_json);
            },
            AddCryptoAddress() {
                const _that = this;
                this.submitted = true;
                this.$validator.validate().then((valid) => {
                    if (valid) {
                        if (_that.depositCurrency != "") {
                            if (_that.apiCryptoAddress != "") {
                                _that.cryptoConvirsion();
                            } else {
                                let conversion_json = {
                                    globalParams: {
                                        address: _that.CryptoAddress,
                                        payment_method: _that.cryptoMethods[_that.depositCurrency],
                                        currency: "BTC",
                                    },
                                    localParams: {
                                        parameter: _that,
                                    },
                                };
                                conversion_json.globalParams.currency = _that.addcrptoCurr;
                                // if(parseInt(this.get_user.profile.user_id) == 641 || parseInt(this.get_user.profile.user_id) == 510 || parseInt(this.get_user.profile.user_id) == 10141){
                                // }
                                _that._runAddCryptoMethod(conversion_json);
                            }
                        }
                    }
                });
            },
            cryptoConvirsion() {
                let conversion_json = {
                    globalParams: {
                        amount: this.OnlyUsers() ? "5" : this.amount, // added conditon for testing purpse only, will remove after trested by harpreet sir
                        from: this.currency_selected,
                        to: "BTC",
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                if(this.selectcurrency.includes("(TRC20)")){
                    this.selectcurrency = this.selectcurrency.replace('(TRC20)','')
                }
                conversion_json.globalParams.to = this.selectcurrency;
                // if(parseInt(this.get_user.profile.user_id) == 641 || parseInt(this.get_user.profile.user_id) == 510 || parseInt(this.get_user.profile.user_id) == 10141){
                // }
                if (this.addcrptoCurr != "") {
                    conversion_json.globalParams.to = this.selectcurrency;
                    this.selectcurrency = this.addcrptoCurr;
                }
                this._runBitcoinConversion(conversion_json);
            },
            changeCrypto(key) {
                if (this.depositCurrency != key) {
                    this.depositCurrency = key;
                    this.apiCryptoAddress = "";
                    this.CryptoAddress = "";
                    this.clickMe = false;
                    let input_json = {
                        globalParams: {
                            payment_method: this.cryptoMethods[this.depositCurrency],
                        },
                        localParams: {
                            parameter: this,
                        },
                    };
                    this._runGetCryptoMethod(input_json);
                }
            },
            cryptDepositFunc() {
                this.cryptoDepositAddress = "";
                let input_json = {
                    globalParams: {
                        account_id: this.account_id,
                        amount: this.bitcoinConversionData.converted_amount,
                        currency: this.selectcurrency,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                this._runCryptoDeposit(input_json);
            },
            getTransactionId() {
                let input_json = {
                    globalParams: {
                        amount: this.amount,
                        currency: this.currency_selected,
                        account_id: this.account_id,
                        method_id: this.get_method_id,
                        ip_country: this.userCountry,
                    },
                    localParams: {
                        parameter: this,
                    },
                };
                if (parseInt(this.get_method_id) == 3) {
                    input_json.globalParams["payment_method_email"] = this.withdrawalMethodResponse[this.get_method_id] ? this.withdrawalMethodResponse[this.get_method_id][0].online_payment_id : "";
                }
                this._runCreditCardDeposit(input_json);
            },
            validateValue() {
                const _that = this;
                this.submitted = true;
                this.$validator.validate().then((valid) => {
                    if (valid) {
                        if (this.checkSuccessDeposit()) {
                            if (parseInt(this.get_method_id) == 1) {
                                if (parseInt(this.amount) == 0 || parseFloat(this.amount) < this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()]) {
                                    this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositLimitCurrencyWise[this.currency_selected.toUpperCase()] + " " + this.currency_selected;
                                } else {
                                    this.amount_msz_error = "";
                                    this.shwStep = 3;
                                    this.bankDeposit();
                                }
                            } else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33].includes(parseInt(this.get_method_id))) {
                                /*else if(parseInt(this.get_method_id) == 1 && (this.get_user.profile.residence_country == 'VN' || this.get_user.profile.residence_country == 'ZA' || this.get_user.profile.residence_country == 'ID')){
                            if((parseInt(this.amount)==0) || (parseFloat(this.amount) < this.limit)){
                                this.amount_msz_error = this.$t('dep_acc_fund_MinDepAmt') +':' + this.limit +" "+ this.currency_selected
                            }else{
                                this.amount_msz_error = ''
                                this.bankDepositForFewCountries()
                            }
                        }*/
                                if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                    this.amount_msz_error = "";
                                    if (this.currency_selected.toUpperCase() == "ZAR") {
                                        if (this.checkSuccessDeposit()) {
                                            _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 80;
                                        } else {
                                            _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 800;
                                        }
                                    } else {
                                        _that.depositMinAllowedValue = {
                                            1: { min_amount: 500 },
                                            2: { min_amount: 5 },
                                            3: { min_amount: 5 },
                                            5: { min_amount: 5 },
                                            6: { min_amount: 5 },
                                            7: { min_amount: 5 },
                                            8: { min_amount: 5 },
                                            9: { min_amount: 5 },
                                            10: { min_amount: 5 },
                                            17: { min_amount: 5 },
                                            18: { min_amount: 5 },
                                            24: { min_amount: 5 },
                                            25: { min_amount: 5 },
                                            26: { min_amount: 5 },
                                            27: { min_amount: 50 },
                                            31: { min_amount: 50 },
                                            32: { min_amount: 5 },
                                            33: { min_amount: 5 },
                                        };
                                        if (_that.get_method_id == 24) {
                                            _that.depositMinAllowedValue[24].min_amount = Math.ceil(((this.amountLimit[this.addhelp2payCurr] || {}).minlength || 1) / this.conversion_unit);
                                        }
                                    }
                                    if (parseFloat(this.amount) < parseFloat(_that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount) && ![24].includes(parseInt(this.get_method_id))) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount + " " + this.currency_selected;
                                    } else if (parseFloat(this.amount) == 0 && ![24].includes(parseInt(this.get_method_id))) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount + " " + this.currency_selected;
                                    } else {
                                        this.amount_msz_error = "";
                                        if (parseInt(this.get_method_id) == 5) {
                                            this.shwStep = 5;
                                        } else if (parseInt(this.get_method_id) == 3) {
                                            this.shwStep = 6;
                                        } else if (parseInt(this.get_method_id) == 2) {
                                            this.shwStep = 7;
                                        } else if (parseInt(this.get_method_id) == 17) {
                                            this.shwStep = 8;
                                        } else if (parseInt(this.get_method_id) == 18) {
                                            this.amount_msz_error = "";
                                            this.AddCryptoAddress();
                                        } else if (parseInt(this.get_method_id) == 25) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetSwiffyDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 24) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                    to_currency: this.addhelp2payCurr,
                                                    bank: this.addhelp2payBank,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetHelp2PayDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 26) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetPayguruDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 27) {
                                            this.doc_error = '';
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                    payment_method_code: this.pay_option,
                                                    document: this.document,
                                                    phone: this.countrycode + this.phone,
                                                    document_type: this.document_type,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetAstroPayDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 31) {
                                            let input_json = {
                                                globalParams: {
                                                    payment_amount: this.amount,
                                                    // payment_amount: '0.1',
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetPerfectMoneyDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 32) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetNuveiDetail(input_json);
                                        } else if (parseInt(this.get_method_id) == 33) {
                                            let input_json = {
                                                globalParams: {
                                                    amount: this.amount,
                                                    currency: this.currency_selected,
                                                    account_id: this.account_id,
                                                    method_id: this.get_method_id,
                                                },
                                                localParams: {
                                                    parameter: this,
                                                },
                                            };
                                            this._runGetTrustPayDetail(input_json);
                                        }
                                    }
                                } else {
                                    this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                                }
                            } else if (parseInt(this.get_method_id) == 23) {
                                /*else if (parseInt(this.get_method_id) == 18) {
                            this.amount_msz_error = "";
                            this.AddCryptoAddress();
                        }*/
                                this.paysafeCheckout();
                            }
                        } else {
                            if (this.currency_selected.toUpperCase() == "ZAR") {
                                /*if(parseInt(this.amount) == 0 || parseFloat(this.amount) < 800){
                                this.amount_msz_error = this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                            }
                            this.depositLimitCurrencyWise[
                                this.currency_selected.toUpperCase()
                              ] = 800*/
                                if (parseInt(this.get_method_id) == 1) {
                                    if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 800) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                    } else {
                                        this.amount_msz_error = "";
                                        this.shwStep = 3;
                                        this.bankDeposit();
                                    }
                                } else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33].includes(parseInt(this.get_method_id))) {
                                    /*else if(parseInt(this.get_method_id) == 1 && (this.get_user.profile.residence_country == 'VN' || this.get_user.profile.residence_country == 'ZA' || this.get_user.profile.residence_country == 'ID')){
                                if((parseInt(this.amount)==0) || (parseFloat(this.amount) < this.limit)){
                                    this.amount_msz_error = this.$t('dep_acc_fund_MinDepAmt') +':' + this.limit +" "+ this.currency_selected
                                }else{
                                    this.amount_msz_error = ''
                                    this.bankDepositForFewCountries()
                                }
                            }*/
                                    if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                        this.amount_msz_error = "";
                                        /*if(this.currency_selected.toUpperCase() == 'ZAR'){
                                      if(this.checkSuccessDeposit()){
                                        _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 80
                                      }else{
                                        _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 800
                                      }
                                    }*/
                                        if (parseInt(this.amount) < 800 && ![24].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                        } else if (parseInt(this.amount) == 0 && ![24].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 800 + " " + this.currency_selected;
                                        } else {
                                            this.amount_msz_error = "";
                                            if (parseInt(this.get_method_id) == 5) {
                                                this.shwStep = 5;
                                            } else if (parseInt(this.get_method_id) == 3) {
                                                this.shwStep = 6;
                                            } else if (parseInt(this.get_method_id) == 2) {
                                                this.shwStep = 7;
                                            } else if (parseInt(this.get_method_id) == 17) {
                                                this.shwStep = 8;
                                            } else if (parseInt(this.get_method_id) == 18) {
                                                this.amount_msz_error = "";
                                                this.AddCryptoAddress();
                                            } else if (parseInt(this.get_method_id) == 25) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetSwiffyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 24) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addhelp2payCurr,
                                                        bank: this.addhelp2payBank,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetHelp2PayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 26) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPayguruDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 27) {
                                                this.doc_error = '';
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        payment_method_code: this.pay_option,
                                                        document: this.document,
                                                        phone: this.countrycode + this.phone,
                                                        document_type: this.document_type,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetAstroPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 31) {
                                                let input_json = {
                                                    globalParams: {
                                                        payment_amount: this.amount,
                                                        // payment_amount: '0.1',
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPerfectMoneyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 32) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetNuveiDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 33) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetTrustPayDetail(input_json);
                                            }
                                        }
                                    } else {
                                        this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                                    }
                                } else if (parseInt(this.get_method_id) == 23) {
                                    /*else if (parseInt(this.get_method_id) == 18) {
                            this.amount_msz_error = "";
                            this.AddCryptoAddress();
                            } */
                                    this.paysafeCheckout();
                                }
                            } else {
                                if (parseInt(this.get_method_id) == 1) {
                                    if (parseInt(this.amount) == 0 || parseFloat(this.amount) < 50) {
                                        this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                    } else {
                                        this.amount_msz_error = "";
                                        this.shwStep = 3;
                                        this.bankDeposit();
                                    }
                                }
                                // else if(parseInt(this.get_method_id) == 1 && (this.get_user.profile.residence_country == 'VN' || this.get_user.profile.residence_country == 'ZA' || this.get_user.profile.residence_country == 'ID')){
                                //                  if((parseInt(this.amount)==0) || (parseFloat(this.amount) < this.limit)){
                                //  this.amount_msz_error = this.$t('dep_acc_fund_MinDepAmt') +':' + this.limit +" "+ this.currency_selected
                                // }else{
                                //  this.amount_msz_error = ''
                                //  this.bankDepositForFewCountries()
                                // }
                                //                }
                                else if ([5, 3, 2, 17, 18, 24, 25, 26, 27, 31, 32, 33].includes(parseInt(this.get_method_id))) {
                                    if (parseFloat(this.amount) <= parseFloat(this.MinValue)) {
                                        this.amount_msz_error = "";
                                        /*if(this.currency_selected.toUpperCase() == 'ZAR'){
                                      if(this.checkSuccessDeposit()){
                                        _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 80
                                      }else{
                                        _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount = 800
                                      }
                                    }*/
                                        if (parseInt(this.amount) < 50 && ![24, 27].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                        } else if (parseInt(this.amount) == 0 && ![24, 27].includes(parseInt(this.get_method_id))) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + 50 + " " + this.currency_selected;
                                        } else if ([27].includes(parseInt(this.get_method_id)) && parseInt(this.amount) < this.depositMinAllowedValue[27].min_amount) {
                                            this.amount_msz_error = this.$t("dep_acc_fund_MinDepAmt") + ":" + this.depositMinAllowedValue[27].min_amount + " " + this.currency_selected;
                                        } else {
                                            this.amount_msz_error = "";
                                            if (parseInt(this.get_method_id) == 5) {
                                                this.shwStep = 5;
                                            } else if (parseInt(this.get_method_id) == 3) {
                                                this.shwStep = 6;
                                            } else if (parseInt(this.get_method_id) == 2) {
                                                this.shwStep = 7;
                                            } else if (parseInt(this.get_method_id) == 17) {
                                                this.shwStep = 8;
                                            } else if (parseInt(this.get_method_id) == 18) {
                                                this.amount_msz_error = "";
                                                this.AddCryptoAddress();
                                            } else if (parseInt(this.get_method_id) == 25) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetSwiffyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 24) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        to_currency: this.addhelp2payCurr,
                                                        bank: this.addhelp2payBank,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetHelp2PayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 26) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPayguruDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 27) {
                                                this.doc_error = '';
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                        payment_method_code: this.pay_option,
                                                        document: this.document,
                                                        phone: this.countrycode + this.phone,
                                                        document_type: this.document_type,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetAstroPayDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 31) {
                                                let input_json = {
                                                    globalParams: {
                                                        payment_amount: this.amount,
                                                        // payment_amount: '0.1',
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetPerfectMoneyDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 32) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetNuveiDetail(input_json);
                                            } else if (parseInt(this.get_method_id) == 33) {
                                                let input_json = {
                                                    globalParams: {
                                                        amount: this.amount,
                                                        currency: this.currency_selected,
                                                        account_id: this.account_id,
                                                        method_id: this.get_method_id,
                                                    },
                                                    localParams: {
                                                        parameter: this,
                                                    },
                                                };
                                                this._runGetTrustPayDetail(input_json);
                                            }
                                        }
                                    } else {
                                        this.amount_msz_error = this.$t("dep_maxdeposit") + this.MinValue + " " + this.currency_selected;
                                    }
                                } else if (parseInt(this.get_method_id) == 23) {
                                    /*else if (parseInt(this.get_method_id) == 18) {
                            this.amount_msz_error = "";
                            this.AddCryptoAddress();
                            } */
                                    this.paysafeCheckout();
                                }
                            }
                        }
                        document.getElementById("form").scrollIntoView({
                            behavior: "smooth",
                        });
                    } else {
                        _that.handleValidationErrorAdvanced(_that.errors);
                    }
                });
            },
            paysafeCheckout() {
                paysafe.checkout.setup(
                    "T1QtODUzMzgwOkItcWEyLTAtNjIxYzgwNmMtMC0zMDJjMDIxNDJkNzM2OGY0NWVjMDczZTc0YmRlMjIwZGUzNTJkZTQ0MDRhY2NkZjQwMjE0MDUzM2JkNDkxZDZjNDgxODE5NzRmYzdkOWFhYTkxZjcwYjdiMmY1NA==",
                    {
                        merchantRefNum: "T1QtODUzMzgwOkItcWEyLTAtNjIxYzgwNmMtMC0zMDJjMDIxNDJkNzM2OGY0NWVjMDczZTc0YmRlMjIwZGUzNTJkZTQ0MDRhY2NkZjQwMjE0MDUzM2JkNDkxZDZjNDgxODE5NzRmYzdkOWFhYTkxZjcwYjdiMmY1NA==",
                        amount: this.amount * 100,
                        currency: "EUR",
                        environment: "TEST",
                        holderName: this.get_user.username,
                        companyName: "FXView",
                        billingAddress: {
                            country: this.get_user.profile.residence_country,
                            zip: this.get_user.profile.post_code,
                            city: this.get_user.profile.city,
                            street: this.get_user.profile.address1,
                            street2: this.get_user.profile.address2,
                        },
                    },
                    (instance, error, result) => {
                        if (!error) {
                            if (result.token) {
                                instance.showSuccessScreen();
                                if (result.paymentMethod == "Cards") {
                                    console.log("result", result);
                                    console.log("error", error);
                                    console.log("instance", instance);
                                    // this.paysafeCardCall(result.token);
                                    // use AJAX to send result.token to your merchant server to take CC payment
                                }

                                if (result.paymentMethod == "DirectDebit") {
                                    // use AJAX to send result.token to your merchant server to take DD payment
                                }

                                if (result.paymentMethod == "Interac") {
                                    // use AJAX to send result.token to your merchant server to take Interac payment
                                }

                                if (result.paymentMethod == "PayPal") {
                                    // use AJAX to send result.token to your merchant server to take PayPal payment
                                }
                            } else {
                                // error handling
                            }
                        } else {
                            instance.showFailureScreen();
                        }
                    }
                );
            },
            paysafeCardCall(token) {
                console.log("asdadasd", token);
                axios
                    .post(
                        "https://api.test.paysafe.com/cardpayments/v1/accounts/1002371220/auths",
                        {
                            merchantRefNum: new Date().getTime(),
                            settleWithAuth: true,
                            amount: this.amount * 100,
                            card: {
                                paymentToken: token,
                            },
                        },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Basic dGVzdF9wcl90ZXN0OkItcWEyLTAtNjIxYzVmZDYtMC0zMDJjMDIxNDBmZjQwZjZkYmEzYTc0ZjAyMjlmZDQ1Yjg5YzJkMjBlMDRiMzJlY2EwMjE0NGMyM2QyNDM3YzFkNTZjNDJmN2MzNTFhZjJhOGM5MzMwMmNmZDk4MA==",
                            },
                        }
                    )
                    .then((response) => {
                        console.log(response);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
            bankDeposit() {
                const _that = this;
                let form_name = new FormData();

                let comment =
                    this.$t("dep_pleaseDeposit") +
                    " " +
                    this.currency_selected +
                    " " +
                    this.amount +
                    " " +
                    this.$t("dep_pleaseDeposit1") +
                    this.$t("dep_AccNumber") +
                    " " +
                    this.bankData.account_no +
                    " " +
                    this.$t("dep_holdername") +
                    " " +
                    this.bankData.holder_name +
                    " " +
                    this.$t("dep_bankname") +
                    " " +
                    this.bankData.bank_name +
                    " " +
                    this.$t("dw_bankCode") +
                    " " +
                    this.bankData.bank_code +
                    " " +
                    this.$t("dep_brsortCode") +
                    " " +
                    this.bankData.sort_code +
                    " " +
                    this.$t("dep_brbankAdress") +
                    " " +
                    this.bankData.bank_address;
                form_name.append("reason", 120);
                form_name.append("reason_text", "BANK DEPOSIT");
                form_name.append("title", 0);
                form_name.append("title_text", "");
                form_name.append("text", comment);
                form_name.append("ip_country", this.userCountry);

                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                form: form_name,
                            },
                            localParams: {
                                parameter: _that,
                                module: "ticket-reply",
                            },
                        };
                        _that._runTicketRequestOtp(input_json);
                    }
                });
            },
            bankDepositForFewCountries() {
                const _that = this;
                _that.$validator.validate().then((valid) => {
                    if (valid) {
                        let input_json = {
                            globalParams: {
                                amount: _that.amount,
                                currency: _that.currency_selected,
                                account_id: _that.account_id,
                                country: _that.get_user.profile.residence_country,
                                ip_country: this.userCountry,
                                "payment_method ": _that.payment_method_acc_to_country[_that.get_user.profile.residence_country],
                            },
                            localParams: {
                                parameter: _that,
                            },
                        };
                        _that._runBankDepositForFewCountries(input_json);
                    }
                });
            },
            reset() {
                this.account_id = "";
                this.act_account_id = "";
                this.amount = "";
                this.bankData = {};
                this.pay_option = "";
                this.submitted = false;
                this.get_method_id = "";
                this.document = "";
                this.phone = "";
            },
            submitPay(transaction_id) {
                this.transaction_id = transaction_id;

                setTimeout(function () {
                    document.getElementById("skrillForm").submit();
                }, 3000);
            },
            documentValidation() {
                this.doc_error = '';
            },
            conversionAmount() {
                if (this.timeout) clearTimeout(this.timeout); 
                this.timeout = setTimeout(() => {
                    const _that = this;
                    if(this.pay_option == 'IX') {
                        let input_json = {
                            globalParams: {
                                amount: _that.amount,
                                currency: _that.currency_selected,
                            },
                            localParams: {
                                parameter: _that,
                            },
                        };
                        _that._runAstropayCurrencyConversion(input_json);
                    }
                }, 500); // delay
            },
        },
        props: ["callFrom"],
        created() {
            this._runGetUserIp({
                globalParams: {},
                localParams: {
                    parameter: this,
                },
            });
            if (this.$store.getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE] != "") {
                this.loaderFuncRun = "0";
            }
            this._runGetWithdrawalMethods({
                globalParams: {},
                localParams: {
                    parameter: this,
                    loaderFuncRun: this.loaderFuncRun,
                },
            });

            if (this.callFrom != "" && this.callFrom != null && this.callFrom != undefined) {
                this.account_id = this.walletAccount.recamount_hpords[0].account_id;
                this.act_account_id = this.walletAccount.records[0].act_account_id;
                this.currency_selected = this.walletAccount.records[0].currency;
                this.shwStep = 2;
                this.transactionLimitCurrency();
            }
            //===comes from manage-account-page
            if (this.$route.params.account_id) {
                this.account_id = this.$route.params.account_id;
                this.act_account_id = this.$route.params.act_account_id;
                this.currency_selected = this.$route.params.currency;
                this.shwStep = 2;
                this.transactionLimitCurrency();
            }

            //comes from ticket add new bank page
            if (this.$route.params.account_id_from_ticket) {
                this.shwStep = 2;
                this.response_msg = "suceessMsz20";
                this.msg_type = "success";
                this.account_id = this.$route.params.account_id_from_ticket;
            }

            //comes back from credit card deposit page
            let query = Object.assign({}, this.$route.amount_hpquery);
            if (this.$route.query.msg) {
                if (query.msg == "success") {
                    this.response_msg = this.$t("dep_depositDone");
                    this.msg_type = "success";
                } else if (query.msg == "fail") {
                    this.response_msg = this.$t("dep_depositFail");
                    this.msg_type = "error";
                }
                delete query.msg;

                this.$router.replace({
                    query,
                });
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit.vue